import React from 'react'
import { Link } from "react-router-dom";


const Facility = () => {
    return (
        <>




            <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
                <div className="container">
                    <div className="row">
                        <div className="page-heading">
                            <h2 className="wow fadeInUp" data-wow-delay=".3s">Facility</h2>
                            <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                                <li style={{color:"white"}}>
                                    <Link style={{color:"white"}} to="/">Home</Link>
                                </li>
                                <li><i style={{color:"white"}} className="fa-solid fa-chevron-right" /></li>
                                <li>Facility</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="choose-us-section-2 section-padding fix">
                <div className="pen-shape float-bob-y">
                    <img src="assets/img/shape/mark-pen.png" alt="img" />
                </div>
                <div className="container">
                    <div className="section-title text-center">
                        <h2 className="wow fadeInUp" data-wow-delay=".3s" style={{ fontSize: "32px" }}>
                            Our Facility
                        </h2>
                    </div>
                    <div className="choose-us-wrapper-2">
                        <div className="row g-4 align-items-center">
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-item">
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="content">
                                            <h3 style={{ fontSize: "17px" }}>Laboratories</h3>
                                            <p>
                                                The school has well equipped laboratories for Physics, Chemistry, Biology and Mathematics
                                            </p>
                                        </div>
                                        <div className="icon">
                                            <i className="flaticon-chapter" />
                                        </div>
                                    </div>
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="content">
                                            <h3 style={{ fontSize: "17px" }}>Sports</h3>
                                            <p>
                                                A good combination of indoor as well as outdoor games in the school ensures a balanced development of the students. Sports tournaments are held from time to time.
                                            </p>
                                        </div>
                                        <div className="icon">
                                            <i className="flaticon-learning" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Our Learning.webp" alt="img" className="wow img-custom-anim-top" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <div className="mask-shape">
                                        <img src="assets/img/shape/mask-shape.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6">
                                <div className="choose-us-item style-2">
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="icon">
                                            <i className="flaticon-watching-a-movie" />
                                        </div>
                                        <div className="content style-2">
                                            <h3 style={{ fontSize: "17px" }}>Smart Class</h3>
                                            <p>
                                                Keeping latest development in the education field in mind, school has introduced smart class Facility. It will help the students to learn through interaction method.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="choose-us-box wow fadeInUp" data-wow-delay=".3s">
                                        <div className="icon">
                                            <i className="flaticon-abstract" />
                                        </div>
                                        <div className="content style-2">
                                            <h3 style={{ fontSize: "17px" }}>Environment of belonging</h3>
                                            <p>
                                                making learning meaningful by creating paths towards sustained growth.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="choose-us-section pb-0 section-bg fix bg-cover" style={{ backgroundImage: 'url(assets/img/choose-us/bg-1.png)', marginTop:"-90px" }}>
                <div className="container">
                    <div className="choose-us-wrapper">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Computer Lab.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">
                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Computer Lab
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            Additionally, it features a state-of-the-art computer lab for students in Classes V through XII. Senior students get access to the internet as well. We now have a separate computer lab for senior secondary students after the computer lab was expanded.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Transport.webp" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Transport
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            Only day scholars have access to bus services. It is not possible to withdraw this facility in between sessions. It is asked that parents drop their kids off at the bus stop at least ten minutes early in the morning and pick them up at the same stop in the afternoon. The transportation department sets the bus stop for each route. It is anticipated that students who use the bus service would stay for the entire class. The whole cost of the session must be paid if someone needs the bus service in between sessions. Between sessions, there is no withdrawal from the bus facility. If so, the full session transportation fare will be billed.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Medical Facilities.jpg" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">
                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Medical Facilities
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            As the Medical Officer, a qualified and experienced doctor makes frequent visits to the hostel. Students undergo medical examinations, and a record is kept. If the doctor determines that a kid requires special medical care, the parents or local guardians are notified. Students who experience minor injuries during training, sports, or games are promptly attended to, and the office has a well-stocked first aid kit available 24/7. The school has one car on standby in case of an emergency.
                                        </p>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Science Lab.png" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Science Lab
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            For students in Classes V–XII, it also has a cutting-edge science lab. The lab is also open to senior students. The senior secondary pupils now have their own science lab thanks to the expansion of the science lab.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="row g-4 align-items-center mt-lg-5">
                            <div className="col-lg-6">
                                <div className="choose-us-image">
                                    <img src="assets/img/svp/Library.JFIF" alt="img" style={{ borderRadius: "10px" }} className="wow img-custom-anim-left" data-wow-duration="1.3s" data-wow-delay="0.3s" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="choose-us-content">
                                    <div className="section-title">

                                        <h2 style={{ fontSize: "28px" }} className="wow fadeInUp" data-wow-delay=".3s">
                                            Library
                                        </h2>
                                        <p className="mt-3 mt-mb-0 wow fadeInUp" data-wow-delay=".5s">
                                            Books, movies, recorded sound, magazines, realia, and digital media are all found at school libraries, just like in public libraries. These resources are intended to improve and broaden the school curriculum in addition to providing entertainment, education, and enjoyment for all members of the school community.
                                        </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>



        </>
    )
}

export default Facility